import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import SchemaHasInstructionsGate from '../SchemaHasInstructionsGate';

// Selectors
import { makeSelectEventValue } from '../../services/events/selectors';

interface Props {
    children: React.Node;
    schemaId: ?number;
}

export class EventSchemaHasInstructionsGate extends React.PureComponent<Props> {
    render() {
        const { children, schemaId } = this.props;
        return (
            <SchemaHasInstructionsGate schemaId={schemaId}>
                {children}
            </SchemaHasInstructionsGate>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    schemaId: makeSelectEventValue('schemaId')
});

export default connect(mapStateToProps)(EventSchemaHasInstructionsGate);
